// Música ambiente generativa (WebAudio puro, zero assets/licenças): pads em
// progressão lenta com osciladores detunados + lowpass. Volume no bus music.
export class MusicGen {
  private ctx: AudioContext | null = null;
  private bus: GainNode | null = null;
  private timer: ReturnType<typeof setInterval> | null = null;
  private step = 0;

  // progressão Am → F → C → G (frequências fundamentais graves)
  private chords: number[][] = [
    [110.0, 130.81, 164.81],  // A2 C3 E3
    [87.31, 130.81, 174.61],  // F2 C3 F3
    [98.0, 130.81, 164.81],   // G2(C/G feel) C3 E3
    [98.0, 123.47, 146.83],   // G2 B2 D3
  ];

  start(ctx: AudioContext, destination: AudioNode): void {
    if (this.ctx) return;
    this.ctx = ctx;
    this.bus = ctx.createGain();
    this.bus.gain.value = 1;
    this.bus.connect(destination);
    this.playChord();
    this.timer = setInterval(() => this.playChord(), 6000);
  }

  private playChord(): void {
    if (!this.ctx || !this.bus) return;
    const t = this.ctx.currentTime;
    const chord = this.chords[this.step % this.chords.length]!;
    this.step++;
    for (const f of chord) {
      for (const det of [-4, 4]) { // par detunado por nota
        const osc = this.ctx.createOscillator();
        osc.type = 'sawtooth';
        osc.frequency.value = f * 2; // uma oitava acima do fundamental
        osc.detune.value = det;
        const lp = this.ctx.createBiquadFilter();
        lp.type = 'lowpass';
        lp.frequency.setValueAtTime(300, t);
        lp.frequency.linearRampToValueAtTime(700, t + 3);
        lp.frequency.linearRampToValueAtTime(300, t + 6.4);
        const g = this.ctx.createGain();
        g.gain.setValueAtTime(0, t);
        g.gain.linearRampToValueAtTime(0.028, t + 2.2);
        g.gain.linearRampToValueAtTime(0, t + 6.4);
        osc.connect(lp);
        lp.connect(g);
        g.connect(this.bus);
        osc.start(t);
        osc.stop(t + 6.5);
      }
    }
  }

  stop(): void {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}
